var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avex-coach-list"},[_c('avex-coaches-query',{scopedSlots:_vm._u([{key:"default",fn:function(coaches){return [_c('coach-list',{attrs:{"coaches":coaches.data},on:{"click":function($event){return _vm.$emit('click', $event)}}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }